/**
 * Sky Sniffer-specific scoreboard style overrides.
 * Clean, dark, minimal design — no gradients, no glow, flat rows.
 */
import React from 'react';

export const skySnifferScoreboardOverrides: Record<
  string,
  React.CSSProperties
> = {
  // Overall container
  leftPanelDesktop: {
    background: '#0F1624',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: '12px',
  },
  leftPanelMobile: {
    background: '#0F1624',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: '12px 12px 0 0',
  },
  leftPanelMobileExpanded: {
    background: '#0F1624',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: '12px 12px 0 0',
  },
  leftPanelTablet: {
    background: '#0F1624',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: '12px 12px 0 0',
  },
  leftPanelTabletExpanded: {
    background: '#0F1624',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: '12px 12px 0 0',
  },

  // Tabs
  leftPanelTabs: {
    background: '#613c23',
    border: 'none',
    borderRadius: '10px',
    display: 'flex',
    padding: '4px',

    width: '86%', // 🔥 reduce width (adjust: 70–85%)
    maxWidth: '300px', // 🔥 keeps it neat on large screens
    marginLeft: '1px',
  },
  leftPanelTab: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: '11px',
    fontWeight: '400',
    borderRadius: '8px',
  },
  leftPanelTabActive: {
    background: 'rgba(0, 0, 0, 0.6)',
    color: '#e0e0e0',
    fontSize: '11px',
    fontWeight: '500',
    borderRadius: '8px',
  },

  // Round summary / Total Win container
  roundSummaryContainer: {
    background: 'transparent',
    borderRadius: '10px',
    border: 'none',
  },
  totalWinAmount: {
    color: '#d4d4d4',
    fontWeight: '500',
    fontSize: '15px',
  },
  totalWinLabel: {
    color: 'rgba(255,255,255,0.35)',
    fontWeight: '400',
  },
  betCount: {
    color: 'rgba(255,255,255,0.5)',
  },
  betLabel: {
    color: 'rgba(255,255,255,0.3)',
  },

  // Avatar
  avatarImage: {
    width: '20px',
    height: '20px',
    border: '1px solid rgba(255,255,255,0.1)',
  },

  // Progress bar — subtle amber
  progress: {
    //     background: 'rgba(255, 170, 80, 0.25)',
    background: 'rgba(183, 117, 68, 0.3)',
    height: '6px',
    borderRadius: '3px',
    padding: '1px',
  },
  roundProgressBar: {
    background: '#B77544',
    borderRadius: '3px',
  },

  // Table header
  betListHeader: {
    background: 'transparent',
    color: 'rgba(255,255,255,0.3)',
    fontWeight: '400',
    fontSize: '10px',
  },
  betListHeaderItem: {
    color: 'rgba(255,255,255,0.3)',
  },

  // Bet rows — flat dark
  betRow: {
    background: 'transparent',
    borderRadius: '0px',
    borderBottom: '2px solid rgba(255,255,255,0.08)',
  },
  betRowWinner: {
    background: 'rgba(10, 14, 22, 0.6)',
  },
  betRowCell: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: '11px',
    fontWeight: '400',
  },
  username: {
    color: 'rgba(255,255,255,0.6)',
  },

  // Footer
  scoreBoardFooter: {
    background: 'rgba(10, 14, 22, 0.4)',
    borderTop: 'none',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
  },
  provablyFairText: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: '10px',
  },
  scoreBoardFooterText: {
    color: 'rgba(255,255,255,0.25)',
    opacity: '1',
  },
  scoreBoardFooterLink: {
    color: 'rgba(255,255,255,0.35)',
  },

  // Previous result
  previousResultContainer: {
    background: 'rgba(10, 14, 22, 0.6)',
    borderRadius: '10px',
    border: '1px solid rgba(255,255,255,0.04)',
  },
  previousResultLabel: {
    color: 'rgba(255,255,255,0.4)',
  },

  // Top filters
  topFiltersContainer: {
    background: 'rgba(10, 14, 22, 0.6)',
    borderRadius: '10px',
    border: '1px solid rgba(255,255,255,0.04)',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // keep this
    padding: '6px 8px',
  },

  // No bets
  noBetsNotice: {
    color: 'rgba(255,255,255,0.3)',
  },

  // Data list container
  dataListContainer: {},

  // Expand/collapse button
  expandCollapseButton: {
    backgroundColor: '#2A2F36',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: '8px',
    padding: '6px',
  },

  // Top player cards
  topPlayerName: {
    color: 'rgba(255,255,255,0.6)',
  },
  topPlayerDate: {
    color: 'rgba(255,255,255,0.3)',
  },
  topStatValue: {
    color: '#6B8DB5',
  },
  topStatLabel: {
    color: 'rgba(255,255,255,0.3)',
  },
  topCurrencyLabel: {
    color: 'rgba(255,255,255,0.3)',
  },
  topCurrencyValue: {
    color: 'rgba(255,255,255,0.55)',
  },

  // Rounds row
  roundsRow: {
    backgroundColor: 'rgba(10, 14, 22, 0.5)',
    borderRadius: '10px',
  },
  roundsDateCell: {
    color: 'rgba(255,255,255,0.5)',
  },
  roundsShieldContainer: {
    backgroundColor: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.08)',
  },

  // Icon wrapper
  iconWrapper: {
    backgroundColor: 'rgba(255,255,255,0.05)',
  },
};
